import { templates } from "./templates"

/**
 * Returns the object for the template with the given `name`, or `undefined`.
 *
 * @param {String} name
 */

export function getTemplate(name) {
  if (!name) return null

  return templates.find(t => t.name.toLowerCase() === name.toLowerCase())
}
